import React from 'react';
import logo from "../logo.svg";
import {Provider} from 'react-redux'
import store from "../redux/store";
import VoucherPortalForm from "./VoucherPortalForm";

function VoucherPortal(props) {

   const {classes} = props;
   return (
    <Provider store={store}>
      <VoucherPortalForm classes = {classes}></VoucherPortalForm>
    </Provider>
  );
}


export default VoucherPortal
